import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { FaCheckCircle } from 'react-icons/fa';
import styles from './PedidoSucesso.module.css';

function PedidoSucesso() {
   const navigate = useNavigate();
    const location = useLocation();

    // Aqui está o pedido que veio do FecharPedido
    const pedidoCriado = location.state?.pedidoCriado;

    const irParaStatusPedidos = () => {
      navigate('/pedidoscliente');
    };

  useEffect(() => {
    // Confetes animados
    const createConfetti = () => {
      const confetti = document.createElement('div');
      confetti.className = styles.confetti;
      confetti.style.left = Math.random() * 100 + 'vw';
      confetti.style.backgroundColor = `hsl(${Math.random() * 360}, 70%, 60%)`;
      confetti.style.animationDuration = 2 + Math.random() * 2 + 's';
      document.body.appendChild(confetti);
      setTimeout(() => confetti.remove(), 4000);
    };

    const interval = setInterval(createConfetti, 150);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className={styles.container}>
      <div className={styles.mainCard}>
        <FaCheckCircle className={styles.iconSuccess} />
        <h2>Pedido Realizado com Sucesso!</h2>
       
        <button className={styles.btnPrimario} onClick={irParaStatusPedidos}>
          Ver Status do Pedido
        </button>
      </div>

      <footer className={styles.footer}>
      </footer>
    </div>
  );
}

export default PedidoSucesso;
